module.exports = __webpack_public_path__ + "static/media/logo-farm.bb0b1f8c.svg";